/**
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

"use strict";

import * as angular from "angular";
import * as LZString from "lz-string";

angular
  .module("tabsint.routes.welcome", [])

  .directive("welcomeView", function() {
    return {
      restrict: "E",
      templateUrl: "scripts/routes/welcome/welcome.html",
      controller: "WelcomeCtrl",
      scope: {}
    };
  })


	//HG; */18/25 adding file for reading  commit info
  .controller("WelcomeCtrl", function(
    $q,
    $scope,
    $uibModal,
    adminLogic,
    app,
    autoConfig,
    config,
    devices,
    disk,
    examLogic,
    gettextCatalog,
    logger,
    notifications,
    router,
    tabsintReceiver,
	file
  ) {
    $scope.app = app;
    $scope.devices = devices;
    $scope.disk = disk;
    $scope.router = router;
    $scope.config = config;

    //HG, So the protocol name can be specified on the web-link
    if (app.browser) {
		
		const publicKey = `-----BEGIN PUBLIC KEY-----
			MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsbTxEDKw36gpxD3r6ePM
			QeL3aiodhKidDzxXYUay/GOz6s4gjX28IGRw1aSuAIWW/btD3u+YdWjCFMe7HoUd
			kpHoRDeqzvJIte/Nm9WwgvYpLCv8xBV7Jj5ZSy7/ajf75935ee6tB6yH656sO3yV
			9MsXgLL7gGBUHnNw63gYVApoP/xIkSSqlStsAgGjlBSKXZlB+h6UExNSMwNWPuBi
			r36VWtzqeCV5ygTqkJbSJ++JJc0KC0hMeTMvfBQWbdPFniK0/4m4W2KiBGC9IyJ3
			ICMsfp2Lm2VJhFZTyuFF3lW3sY00jm4hwjXRCVoBHcuMT7CAt+JovR5kQIWi3mpx
			JQIDAQAB
			-----END PUBLIC KEY-----`;
		
      var protocol = document.URL;
	  
		//HG;12/19/24 so the link is in standard format so its easy to share/copy etc
		// Create a URL object
		const url = new URL(protocol);
		// Get the query string (everything after the '?')
		const queryParams = new URLSearchParams(url.search);

		// Get an array of the keys (parameters) in the query string
		const fields = Array.from(queryParams.keys());

		//old system if name field in URL
		if(fields.indexOf('name')>=0){

			var field_val = {};
			var indexBegin = protocol.indexOf("?");
			var indexEnd = protocol.length;
			protocol = protocol.substring(indexBegin + 1, indexEnd);
			var splitName = protocol.split(",");

			for (var i = 0; i < splitName.length; i++) {
			  var tmp_field_val = splitName[i].split("=");
			  field_val[tmp_field_val[0]] = tmp_field_val[1];
			}
			if (field_val.name.indexOf('@')>=0){
				var tmp_protocol_name_key = field_val.name.split("@");
				field_val.name=tmp_protocol_name_key[0];
				//HG;12/12/24 library is a special case in which the version of library is specicied after the '@'
				if(field_val.name=='library'){
					field_val.publicKey=publicKey;
					//HG;12/12/24 so database can extract tag info (which corresponsds to the version of the library protocol on web-tabsint)
					field_val.version  = tmp_protocol_name_key[1];
					
				}
				field_val.key = tmp_protocol_name_key[1];
			}
			
			//HG; Added so JSON data can be passed by the URL
			if ((unescape(protocol).indexOf('<JSON>')>=0)&(unescape(protocol).indexOf('</JSON>')>=0)){
				var tmp_json_data = unescape(protocol);
				field_val.json_data = JSON.parse(tmp_json_data.substring(tmp_json_data.indexOf('<JSON>')+6,tmp_json_data.indexOf('</JSON>')));
			}	
		}
		else{
			var field_val = {};
			var indexBegin=-1;
			var indexEnd=-1;
			field_val.json_data={};
			
			for(var i=0;i<fields.length;i++){
				const value = Object.fromEntries(queryParams)[fields[i]];
				const numberValue = !isNaN(value) ? Number(value) : value;
				field_val.json_data[fields[i]] = numberValue;
			}
			if('version' in field_val.json_data){
				field_val.name='library';
				field_val.publicKey = publicKey;			
				
				field_val.version = field_val.json_data.version;
				field_val.key = field_val.version;
				//setting them to zero so block bellows process the data
				indexBegin=0;
				indexEnd=0;
			}
		}
		

		if (indexBegin >= 0 && indexEnd >= 0) {
			$scope.disk.protocol = {
				name: field_val.name,
				// path: "protocols/" + field_val.name + "/",
				path: "",
				creator: "hg",
				server: "dosgari",
				demo: true,
				field_val: field_val,
				key:field_val.key,
				json_data:field_val.json_data
			};

			//HG;10/10/25 every upload encrypted so if no key use default (key can be provided through the url)
			if($scope.disk.protocol.key===undefined){
				$scope.disk.protocol.key = publicKey;
			}
			
			
			$scope.disk.protocol.siteId = 1;
			$scope.disk.autoUpload = true;


			//HG;12/12/24 cont. library is a special case in which the version of library is specicied after the '@'
			if('publicKey' in field_val){
				$scope.disk.protocol.publicKey = field_val.publicKey;
			}
			//HG;12/12/24 so database can extract tag and commit info (which corresponsds to the version of the library protocol on web-tabsint)
			if('version' in field_val){
				$scope.disk.protocol.version = field_val.version;
				$scope.disk.protocol.hash = field_val.version;
				examLogic.switchToExamView();
			}

			//HG;10/7/25 if version is in params no need to get commit
			const params = url.searchParams;

			//HG;10/8/25 added here so that name doesn't get combined with other parameters because of the LAGACY way of extracting the repo name from the url
			//HG;10/9/25 to support legacy url format (library is special case)
			var repoNameUrl = field_val.name;
			
			//HG;8/7/26 if URL in format ?name=name, (meaning follwed by the comma) is the old format so don't use params.get("name")
			if((url.href.indexOf('?name='+field_val.name+',')<0)&&params.has("name")&&(field_val.name.toLowerCase()!='library')){
				repoNameUrl = params.get("name");
			}

			var checkUpdate = false;
			if(params.has("update")){
				checkUpdate = (params.get("update")=='true');
			}

			if (params.has("version")&&params.has("name")&&(!checkUpdate)){
				$scope.disk.protocol.name = params.get("name");
				$scope.disk.protocol.hash = params.get("version");
				$scope.disk.protocol.version = params.get("version");
				examLogic.switchToExamView();
			}
			else{
				$scope.disk.protocol.name = repoNameUrl;

				//10/8/25 to for a git fetch those with update set to true
				//HG; 9/18/25 getting commit info so databse can process it as normal gitlab protocol
				//HG; 9/23/25 adding repo name, later we can also add tag OR commit
				file.readFile(`get_protocol/info?repo=${repoNameUrl}&update=${checkUpdate}`).then(function(commitInfo) {
					$scope.disk.protocol.hash = commitInfo.hash;
					$scope.disk.protocol.version = commitInfo.hash;
					examLogic.switchToExamView();
					return $q.defer().promise;
				});			
			}			
		}
    }

    $scope.switchToExamView = function() {
      examLogic.switchToExamView();
    };

    $scope.switchToAdminView = function() {
      adminLogic.switchToAdminView();
    };

    /**
     * Scan Config Qr code and load it into the config object
     */
    $scope.scanQrCodeandAutoConfig = function() {
      function scanQrCode() {
        var deferred = $q.defer();
        var scanner;
        // check that QR code scanner is enabled
        try {
          scanner = cordova.plugins.barcodeScanner;
        } catch (e) {
          logger.error("Could not load barcode scanner: " + angular.toJson(e, true));
          deferred.reject("Could not load barcode scanner with error: " + e);
        }
        scanner.scan(
          function(result) {
            let decompressed;

            // try parsing with JSON first for backwards compatibility
            // if this fails, parse with LZString
            try {
              let c = JSON.parse(result.text);
              if (typeof c !== "object") {
                throw "Failed to parse text to object";
              }
              decompressed = result.text;
            } catch (e) {
              decompressed = LZString.decompressFromBase64(result.text);
            }

            logger.debug("QR Scan: " + decompressed);

            $scope.$apply(function() {
              if (result.cancelled) {
                deferred.reject("Scanning cancelled");
              }

              // confirm we can read object
              try {
                let c = JSON.parse(decompressed);
                if (typeof c !== "object") {
                  deferred.reject("Failed to read configuration");
                }
              } catch (e) {
                deferred.reject("Failed to parse configuration text");
              }

              deferred.resolve(decompressed);
            });
          },
          function(result) {
            $scope.$apply(function() {
              deferred.reject("Scanner failed with error: " + angular.toJson(result, true));
            });
          },
          {
            orientation: "landscape",
            formats: "QR_CODE, PDF_417, CODE_128", // default: all but PDF_417 and RSS_EXPANDED
            disableSuccessBeep: true
          }
        );
        return deferred.promise;
      }

      return scanQrCode()
        .catch(function(e) {
          if (e !== "Scanning cancelled") {
            notifications.alert(
              gettextCatalog.getString("TabSINT failed to read configuration code error: ") + angular.toJson(e, true)
            );
          }

          return $q.reject();
        })
        .then(function(configObject) {
          return config.load(configObject, true);
        }) // Load the configuration Qr Code into the config object
        .then(autoConfig.load); // Act on the config object: apply admin settings, load protocol and exam view
    };

    var DisclaimerInstanceCtrl = function($scope, $uibModalInstance, disk) {
      $scope.ok = function() {
        $uibModalInstance.close();
        disk.init = false;
      };
    };

    app
      .ready()
      .then(function() {
        //HG;so browser don't show disclaimer
        if (disk.init & !app.browser) {
          // only run when the app loads for the first time (when disk.init is true)
          let disclaimerModal = $uibModal.open({
            templateUrl: "scripts/routes/welcome/disclaimer.html",
            controller: DisclaimerInstanceCtrl //is there a reason not to use this simplistic logic?
          });
          return disclaimerModal.result;
        }
      })
      .then(function() {
        if (
          disk.versionCheck == false &&
          devices.platform.toLowerCase() === "android" &&
          parseInt(devices.version) >= 11
        ) {
          disk.versionCheck = true;
        }
      })
      .then(function() {
        tabsintReceiver.handleExternalAppData(autoConfig.androidIntentCallback); //registering androidIntentCallback on welcome
      });
  });
